// =============================================================================
// COMMON API PARAMETERS
// =============================================================================
import axios from "axios";
import {opdEmr} from "../utils/constant";

// accessing JWT token
function getJWTtoken() {
  let token = localStorage.getItem("callKey");
  if (typeof window !== "undefined") {
    return token;
  } else if (token === undefined) {
    return null;
  } else {
    return null;
  }
}
let JWTresponse = getJWTtoken();

// =============================================================================
// HEADER OPTIONS FOR PROTECTED AND UNPROTECTED APIs
// =============================================================================

const getHeaders = () => {
  if (JWTresponse === null) {
    return {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
  } else {
    return {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${JWTresponse}`,
      },
    };
  }
};

let Header = getHeaders();
// =============================================================================
// SETTING UP SINGLE AXIOS INSTANCE
// =============================================================================

const opdEmraxiosClient = axios.create({
  // baseURL: `http://c6ed-182-71-137-235.ngrok.io/api/v1`,
  // baseURL:
  //   process.env.NODE_ENV !== "production"
  baseURL: opdEmr
  // Header,
});

// =============================================================================
// AXIOS INTERCEPTOR FOR UNAUTHORIZED API CALLS
// =============================================================================
opdEmraxiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // let res = error.response;
    // console.error("Looks like there was a problem. Status Code:" + res.status);
    return error.response;
  }
);

//exporting axios client
export default opdEmraxiosClient;